import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const PageNavigator = ({
  currentPage,
  totalPages,
  onPreviousPage,
  onNextPage,
  onGoToPage,
}) => {
  if (totalPages <= 0) {
    return null;
  }

  const handlePageInput = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value >= 1 && value <= totalPages) {
      onGoToPage(value);
    }
  };

  return (
    <div className="flex items-center justify-center gap-2 py-2">
      <button
        onClick={onPreviousPage}
        disabled={currentPage <= 1}
        className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        title="Previous page"
      >
        <ChevronLeft className="w-5 h-5" />
      </button>

      <div className="flex items-center gap-2 text-sm">
        <span className="text-gray-500">Page</span>
        <input
          type="number"
          min={1}
          max={totalPages}
          value={currentPage}
          onChange={handlePageInput}
          className="w-12 text-center px-2 py-1 border border-gray-300 rounded focus:ring-1 focus:ring-yellow-500 focus:border-yellow-500"
        />
        <span className="text-gray-500">of {totalPages}</span>
      </div>

      <button
        onClick={onNextPage}
        disabled={currentPage >= totalPages}
        className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        title="Next page"
      >
        <ChevronRight className="w-5 h-5" />
      </button>
    </div>
  );
};

export default PageNavigator;
